module.exports = __webpack_public_path__ + "static/media/44490720_2199897463418766_4019093935895871488_o-thumb.9c3d04e1.jpg";